import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRightIcon, MenuIcon, XIcon } from "lucide-react";
import { Logo } from "./Logo";
import { navLinks } from "../data/content";
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="absolute inset-x-0 top-0 z-30 px-4 pt-5 sm:px-6" data-id="element-86" data-mp="2nl3j7dgrwqd1">
      <div className="mx-auto max-w-7xl rounded-xl bg-white px-5 py-4 shadow-[0_8px_30px_rgba(35,30,26,0.08)] lg:px-7" data-id="element-87" data-mp="2rm5itvelr4fj">
        <div className="flex items-center justify-between gap-6" data-id="element-88" data-mp="2wkqintpxzm3g">
          <div className="flex items-center gap-8" data-id="element-89" data-mp="2wivxqfeo7tzd">
            <Logo data-id="element-90" data-mp="31d07f6fbmg45" />
            <span className="hidden h-10 w-px bg-line lg:block" aria-hidden="true" data-id="element-91" data-mp="31cgy2e3ql01q" />
            <nav aria-label="Navigation principale" className="hidden lg:block" data-id="element-92" data-mp="369ql5n3nkzme">
              <ul className="flex items-center gap-1" data-id="element-93" data-mp="3baxtpodme2u4">
                {navLinks.map((link, i) => <li key={link.label} data-id="element-94" data-mp="3fayfju31tgb7" data-mpi={i}>
                    <a href={link.href} aria-current={i === 0 ? "page" : undefined} className={`whitespace-nowrap rounded-md px-3.5 py-2 text-[15px] font-medium transition-colors duration-150 ${i === 0 ? "bg-ink text-white" : "text-ink hover:bg-sand"}`} data-id="element-95" data-mp="3f9nei20zmmns">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
            </nav>
          </div>

          <a href="#contact" className="hidden items-center gap-3 whitespace-nowrap rounded-md bg-ink px-6 py-3 text-[15px] font-medium text-white transition-colors duration-150 hover:bg-ink-soft lg:inline-flex" data-id="element-96" data-mp="3abppfpmr161y">
            Prendre rendez-vous
            <ArrowUpRightIcon className="h-4 w-4" data-id="element-97" data-mp="1wfsevxpur11" />
          </a>

          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? "Fermer le menu" : "Ouvrir le menu"} className="flex h-10 w-10 items-center justify-center rounded-md text-ink hover:bg-sand lg:hidden" data-id="element-98" data-mp="1xqumrbijqq1">
            {open ? <XIcon className="h-5 w-5" data-id="element-99" data-mp="1hojlslcyqqiw" /> : <MenuIcon className="h-5 w-5" data-id="element-100" data-mp="1hn8iemnfjksb" />}
          </button>
        </div>

        <AnimatePresence initial={false} data-id="element-101" data-mp="1mltafysj2y5o">
          {open && <motion.nav id="mobile-nav" aria-label="Navigation mobile" initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: "auto",
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.22,
          ease: [0.23, 1, 0.32, 1]
        }} className="overflow-hidden lg:hidden" data-id="element-102" data-mp="18nbqmc5qu5t1">
              <ul className="mt-4 flex flex-col gap-1 border-t border-line pt-4" data-id="element-103" data-mp="2t2x7bjk8utvr">
                {navLinks.map(link => <li key={link.label} data-id="element-104" data-mp="2y29ts377dyxt">
                    <a href={link.href} onClick={() => setOpen(false)} className="block rounded-md px-3 py-2.5 text-[15px] font-medium text-ink hover:bg-sand" data-id="element-105" data-mp="2y18h5uajh4dz">
                      {link.label}
                    </a>
                  </li>)}
                <li className="pt-2" data-id="element-106" data-mp="rd7t190fkxfw">
                  <a href="#contact" onClick={() => setOpen(false)} className="flex items-center justify-center gap-2 rounded-md bg-ink px-5 py-3 text-[15px] font-medium text-white" data-id="element-107" data-mp="rc6h72blc6x4">
                    Prendre rendez-vous
                    <ArrowUpRightIcon className="h-4 w-4" data-id="element-108" data-mp="1f2tslxkpteof" />
                  </a>
                </li>
              </ul>
            </motion.nav>}
        </AnimatePresence>
      </div>
    </header>;
}